export default {
	SLIDER_RUN: 'SliderRun',
};
